export class TakeTruffle {
  id: number;
  takenAt: string = new Date().toString();
  weight: number;
}
